// src/components/CustomToaster.js
import React from "react";
import { Toaster, toast } from "react-hot-toast";
import "./index.css"

const SuccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path d="M11.3996 6.5001C11.3996 9.48244 8.98195 11.9001 5.99961 11.9001C3.01727 11.9001 0.599609 9.48244 0.599609 6.5001C0.599609 3.51776 3.01727 1.1001 5.99961 1.1001C8.98195 1.1001 11.3996 3.51776 11.3996 6.5001Z" fill="#0FAF71" />
        <path d="M3.83984 6.82486L5.07413 8.12086L8.15984 4.88086" stroke="white" strokeWidth="0.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
        <path d="M11.3996 6.5001C11.3996 9.48244 8.98195 11.9001 5.99961 11.9001C3.01727 11.9001 0.599609 9.48244 0.599609 6.5001C0.599609 3.51776 3.01727 1.1001 5.99961 1.1001C8.98195 1.1001 11.3996 3.51776 11.3996 6.5001Z" fill="#D70015" />
        <path d="M3.59961 4.1001L8.39961 8.9001" stroke="white" strokeWidth="0.6" strokeLinecap="round" />
        <path d="M3.59961 8.9001L8.39961 4.1001" stroke="white" strokeWidth="0.6" strokeLinecap="round" />
    </svg>
);

export const showCustomToast = (message = "Success!", type = "success") => {
    const Icon = type === "error" ? ErrorIcon : SuccessIcon;

    toast.custom((t) => (
        <div
            className={`custom-toast ${t.visible ? 'toast-show' : 'toast-hide'}`}
            onClick={() => toast.dismiss(t.id)}
        >
            <Icon />
            <span className="toast-message">{message}</span>
        </div>
    ));
};

const CustomToast = () => (
    <Toaster
        position="bottom-center"
        toastOptions={{
            duration: 4000,
        }}
    />
);

export default CustomToast;
